import { useParams } from 'react-router-dom'
import {RouteProps} from '../../routes/AppRouter'
import {ApplicationDetail} from '../../features/application'
import {Title} from 'components/common/Title'

export function Detail(props: RouteProps) {
    const { id } = useParams<{ id: string }>()
    return (
        <>
            <Title color={"black"} title={props.title || ''}/>
            <ApplicationDetail id={id || props.id || ''}/>
        </>
    )
}
